import React, { useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import './index.scss';

import PropTypes from 'prop-types';
import { ChevronRightIcon, WalletIcon } from './icons';

// import WalletTabs from '../../components/wallet/wallet-tabs';
import WalletHeader from '../../components/wallet/wall-header';
import WalletBalanceCard from '../../components/wallet/wallet-balance-card';
import WalletSectionHeader from '../../components/wallet/wallet-section-header';
import WalletTransactionList from '../../components/wallet/wall-transaction-list';
import WalletTabs from '../../components/wallet/wallet-tabs';
import WalletTransaction from '../../components/wallet/wallet-transaction';
import {
  useWalletSummarySelector,
  useWalletTransactions
} from '../../hooks/useWallet';
import useViewport from '../../hooks/useViewpost';

const tabs = [
  {
    label: 'All',
    value: 'all'
  },
  {
    label: 'Credited',
    value: 'credit'
  },
  {
    label: 'Debited',
    value: 'debit'
  }
];

const BkWalletWithTabs = ({ onNavigate }) => {
  const { isMobile: isMobileScreen } = useViewport();
  const { transactions, handleTabChange, filters } = useWalletTransactions();
  console.log('jitendra===>', transactions);

  const handleGoBack = useCallback(() => {
    if (typeof onNavigate === 'function') onNavigate('without-tabs');
  }, [onNavigate]);

  return (
    <div className="wallet" data-tabs>
      <WalletHeader
        title="All Transactions"
        showBackButton={isMobileScreen}
        onBack={handleGoBack}
      />
      <WalletTabs
        tabs={tabs}
        activeTab={filters.type}
        onChange={handleTabChange}
      />
      <WalletTransactionList
        transactions={transactions}
        className="wallet__transparent-transactions-bg"
        renderItem={transaction => (
          <WalletTransaction
            title={transaction?.description}
            date={transaction?.createdAt}
            amount={transaction?.amount}
            type={(transaction?.transactionType || '').toLowerCase()}
            showIcon={false}
          />
        )}
      />
    </div>
  );
};

BkWalletWithTabs.prototype = {
  onNavigate: PropTypes.func.isRequired
};

const BKWalletWithoutTabs = ({ onNavigate }) => {
  const history = useHistory();
  const { isMobile: isMobileScreen } = useViewport();
  const { recentTransactions, walletAmount } = useWalletSummarySelector();

  const handleGoToViewAll = useCallback(() => {
    if (typeof onNavigate === 'function') onNavigate('tabs');
  }, [onNavigate]);

  const handleGoBack = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <div className="wallet">
      <WalletHeader
        title="BK-Wallet"
        showBackButton={isMobileScreen}
        onBack={handleGoBack}
      />
      <WalletBalanceCard>
        <WalletBalanceCard.Content>
          <WalletBalanceCard.Content.Title>
            Your Balance
          </WalletBalanceCard.Content.Title>
          <WalletBalanceCard.Content.Amount className="wallet__balance-card-amount">
            {walletAmount}
          </WalletBalanceCard.Content.Amount>
        </WalletBalanceCard.Content>
        <WalletBalanceCard.IconWrapper className="wallet__balance-card-icon-wrapper">
          <WalletIcon />
        </WalletBalanceCard.IconWrapper>
      </WalletBalanceCard>
      <div>
        <WalletSectionHeader
          title="Recent Activity"
          actionText="View All"
          className="wallet__trasactions-header"
          titleClassName="heading"
          onAction={handleGoToViewAll}
          icon={ChevronRightIcon}
        />
        <WalletTransactionList
          transactions={recentTransactions}
          className="wallet__transparent-transactions-bg"
          renderItem={transaction => (
            <WalletTransaction
              title={transaction?.description}
              date={transaction?.createdAt}
              amount={transaction?.amount}
              type={(transaction?.transactionType || '').toLowerCase()}
              showIcon
            />
          )}
        />
      </div>
    </div>
  );
};

BKWalletWithoutTabs.protoTypes = {
  onNavigate: PropTypes.func.isRequired
};

const BKWallet = () => {
  const [currentScreen, setCurrentScreen] = useState('tabs');

  const handleGoToScreen = useCallback(tab => setCurrentScreen(tab), [
    currentScreen
  ]);

  return currentScreen !== 'tabs' ? (
    <BKWalletWithoutTabs onNavigate={handleGoToScreen} />
  ) : (
    <BkWalletWithTabs onNavigate={handleGoToScreen} />
  );
};

export default BKWallet;
